import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Constrants from "../constrants/constrant";
import { useToast } from "../context/ToastProvider";
import { useSettings } from "../context/SettingsProvider";

function Register() {
  const { settings } = useSettings();
  const navigate = useNavigate();
  const { addToast } = useToast();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const user = localStorage.getItem("user");
    
    if (token && user) {
    addToast("You are already logged in!", "info", 3000);
    navigate("/");
    }
}, [navigate, addToast]);

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      addToast("Passwords do not match", "error");
      setLoading(false);
      return;
    }

    if (password.length < 8) {
      setError("Password must be at least 8 characters long");
      addToast("Password must be at least 8 characters long", "error");
      setLoading(false);
      return;
    }

    try {
      console.log("Attempting registration with:", { name, email, password: "***" });
      console.log("API Base URL:", Constrants.defaults.baseURL);
      
      const res = await Constrants.post("/register", {
        name,
        email,
        password,
      });

      console.log("Registration response:", res.data);
      console.log("Response status:", res.status);

      if (res.data && res.data.token && res.data.user) {
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("user", JSON.stringify(res.data.user));

        console.log("Registration successful, redirecting to home");
        
        addToast("Registration successful! Welcome!", "success", 4000);
        
        navigate("/");
      } else {
        console.error("Unexpected response structure:", res.data);
        setError("Registration response format is invalid. Please contact support.");
      }
    } catch (err) {
      console.error("Registration error:", err);
      console.error("Error response:", err.response);
      
      if (err.response) {
        const { status, data } = err.response;
        console.log("Error status:", status);
        console.log("Error data:", data);
        
        if (data && data.message) {
          setError(data.message);
          addToast(data.message, "error");
        } else if (data && data.errors) {
          const errors = Object.values(data.errors).flat();
          const errorMessage = errors.join(", ");
          setError(errorMessage);
          addToast(errorMessage, "error");
        } else if (status === 422) {
          const errorMessage = "Please check your input and try again.";
          setError(errorMessage);
          addToast(errorMessage, "error");
        } else if (status === 409 || status === 400) {
          const errorMessage = "This email is already registered.";
          setError(errorMessage);
          addToast(errorMessage, "error");
        } else {
          const errorMessage = `Server error (${status}). Please try again.`;
          setError(errorMessage);
          addToast(errorMessage, "error");
        }
      } else if (err.request) {
        console.error("No response received:", err.request);
        const errorMessage = "Cannot connect to server. Please check your internet connection.";
        setError(errorMessage);
        addToast(errorMessage, "error");
      } else {
        console.error("Request setup error:", err.message);
        const errorMessage = "Something went wrong. Please try again.";
        setError(errorMessage);
        addToast(errorMessage, "error");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="main-content">
      <div className="auth-container">
        <div className="auth-card active" id="registerCard">
          <div className="auth-header">
            <div className="auth-logo">
              <div className="logo-icon" style={{ width: "48px", height: "48px" }}></div>
            </div>
            <h1 className="auth-title">Create Account</h1>
            <p className="auth-subtitle">Sign up to get started</p>
          </div>

          <form className="auth-form" id="registerForm" onSubmit={handleRegister}>
            {error && <div className="form-error" style={{ color: "red", marginBottom: "1rem" }}>{error}</div>}

            <div className="form-group">
              <label htmlFor="registerName" className="form-label">Full Name</label>
              <input
                type="text"
                id="registerName"
                className="form-input"
                placeholder="Enter your full name"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label htmlFor="registerEmail" className="form-label">Email</label>
              <input
                type="email"
                id="registerEmail"
                className="form-input"
                placeholder="Enter your email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label htmlFor="registerPassword" className="form-label">Password</label>
              <input
                type="password"
                id="registerPassword"
                className="form-input"
                placeholder="Create a password (min 8 characters)"
                required
                minLength="8"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
              <input
                type="password"
                id="confirmPassword"
                className="form-input"
                placeholder="Re-enter your password"
                required
                minLength="8"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </div>

            <div className="form-group">
                <label className="checkbox-label">
                    <input type="checkbox" className="form-checkbox" required="" />
                    <span>I agree to the <a href="#" className="link-text">Terms of Service</a> and <a href="#" className="link-text">Privacy Policy</a></span>
                </label>
            </div>

            <button type="submit" className="auth-btn primary" disabled={loading}>
              {loading ? "Creating Account..." : "Create Account"}
            </button>

            <div style={{ textAlign: "center", marginTop: "1rem" }}>
              <p style={{ color: "#5f6368", fontSize: "14px" }}>
                Already have an account?{" "}
                <Link to="/login" style={{ color: "#1a73e8", textDecoration: "none", fontWeight: "500" }}>
                  Sign in
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
      <section className="section">
          <div className="section-header">
              <h2 className="section-title">Why join {settings?.website_name}?</h2>
          </div>
          <div className="categories-grid">
            <div className="category-card">
              <div
                className="category-icon"
                style={{ border: "1px solid #acacacff", alignContent: "center", justifyContent: "center", display: "flex", alignItems: "center" }}
              >
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="white"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"/></svg>              </div>
              <div className="category-name">Access millions of apps</div>
            </div>

            <div className="category-card">
              <div
                className="category-icon"
                style={{ background: "linear-gradient(45deg, #ff9800, #ff5722)", border: "1px solid #acacacff", alignContent: "center", justifyContent: "center", display: "flex", alignItems: "center" }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#e3e3e3"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z"/></svg>
              </div>
              <div className="category-name">Sync across devices</div>
            </div>

            <div className="category-card">
              <div
                className="category-icon"
                style={{ background: "linear-gradient(45deg, #9c27b0, #e91e63)", border: "1px solid #acacacff", alignContent: "center", justifyContent: "center", display: "flex", alignItems: "center" }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#e3e3e3"><g><path d="M0,0h24v24H0V0z" fill="none"/></g><g><path d="M12,2L4,5v6.09c0,5.05,3.41,9.76,8,10.91c4.59-1.15,8-5.86,8-10.91V5L12,2z M18,11.09c0,4-2.55,7.7-6,8.83 c-3.45-1.13-6-4.82-6-8.83V6.31l6-2.12l6,2.12V11.09z M8.82,10.59L7.4,12l3.54,3.54l5.66-5.66l-1.41-1.41l-4.24,4.24L8.82,10.59z"/></g></svg>
              </div>
              <div className="category-name">Secure &amp; private</div>
            </div>

            <div className="category-card">
              <div
                className="category-icon"
                style={{ background: "linear-gradient(45deg, #2196f3, #00bcd4)", border: "1px solid #acacacff", alignContent: "center", justifyContent: "center", display: "flex", alignItems: "center" }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#e3e3e3"><g><rect fill="none" height="24" width="24"/><path d="M16,4c0-1.11,0.89-2,2-2s2,0.89,2,2s-0.89,2-2,2S16,5.11,16,4z M20,22v-6h2.5l-2.54-7.63C19.68,7.55,18.92,7,18.06,7h-0.12 c-0.86,0-1.63,0.55-1.9,1.37l-0.86,2.58C16.26,11.55,17,12.68,17,14v8H20z M12.5,11.5c0.83,0,1.5-0.67,1.5-1.5s-0.67-1.5-1.5-1.5 S11,9.17,11,10S11.67,11.5,12.5,11.5z M5.5,6c1.11,0,2-0.89,2-2s-0.89-2-2-2s-2,0.89-2,2S4.39,6,5.5,6z M7.5,22v-7H9V9 c0-1.1-0.9-2-2-2H4C2.9,7,2,7.9,2,9v6h1.5v7H7.5z M14,22v-4h1v-4c0-0.82-0.68-1.5-1.5-1.5h-2c-0.82,0-1.5,0.68-1.5,1.5v4h1v4H14z"/></g></svg>
              </div>
              <div className="category-name">Family sharing</div>
            </div>

            <div className="category-card">
              <div
                className="category-icon"
                style={{ background: "linear-gradient(45deg, #4caf50, #8bc34a)", border: "1px solid #acacacff", alignContent: "center", justifyContent: "center", display: "flex", alignItems: "center" }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#e3e3e3"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"/></svg>
              </div>
              <div className="category-name">Exclusive rewards</div>
            </div>

            <div className="category-card">
              <div
                className="category-icon"
                style={{ background: "linear-gradient(45deg, #607d8b, #455a64)", border: "1px solid #acacacff", alignContent: "center", justifyContent: "center", display: "flex", alignItems: "center" }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#e3e3e3"><g><rect fill="none" height="24" width="24"/></g><g><path d="M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M19.46,9.12l-2.78,1.15 c-0.51-1.36-1.58-2.44-2.95-2.94l1.15-2.78C16.98,5.35,18.65,7.02,19.46,9.12z M12,15c-1.66,0-3-1.34-3-3s1.34-3,3-3s3,1.34,3,3 S13.66,15,12,15z M9.13,4.54l1.17,2.78c-1.38,0.5-2.47,1.59-2.98,2.97L4.54,9.13C5.35,7.02,7.02,5.35,9.13,4.54z M4.54,14.87 l2.78-1.15c0.51,1.38,1.59,2.46,2.97,2.96l-1.17,2.78C7.02,18.65,5.35,16.98,4.54,14.87z M14.88,19.46l-1.15-2.78 c1.37-0.51,2.45-1.59,2.95-2.97l2.78,1.17C18.65,16.98,16.98,18.65,14.88,19.46z"/></g></svg>
              </div>
              <div className="category-name">24/7 support</div>
            </div>
          </div>

      </section>
    </main>
  );
}

export default Register;